/** Shared constants. */

/** LocalStorage keys — keep as literals so tests can reference them. */
export const STORAGE_KEYS = {
  TOKEN: 'idf_token',
  USER: 'idf_user',
  SIDEBAR_COLLAPSED: 'sidebar-collapsed',
  THEME: 'idf_theme',
} as const
